import DOMPurify from 'dompurify';

/**
 * Şablon içeriği (ReactQuill/AI üretimi olabilen HTML) ekrana basılmadan önce
 * temizlenir. dangerouslySetInnerHTML ile render edilen her yerde kullanılmalı.
 */
export const sanitizeHtml = (html) =>
  DOMPurify.sanitize(html || '', { USE_PROFILES: { html: true } });

export default sanitizeHtml;
